import React, { Component } from "react";
import { Grid, Row, Col, Alert } from "react-bootstrap";

class Forms extends Component {
    constructor(props) {
        super(props);
        this.handleLink = this.handleLink.bind(this);
        this.state = {
            installerRequirements: "https://wrapify.docsend.com/view/wnpxanz",
            installationForm: "https://wrapify.docsend.com/view/55jezgq",
            removalForm: "https://wrapify.docsend.com/view/8dj3wst",
            photoFormUploads: "https://www.cognitoforms.com/Wrapify/PhotoFormUpload",
        }
    }

    handleLink(url) {
        window.open(url)
    }

    render() {
        return (
            <div className="content">
                <Grid fluid>
                    <div className="card">
                        <div className="header">
                            <h4 className="title">Forms</h4>
                        </div>
                        <div className="content">
                            <Row>
                                <Col md={4}>
                                    <Alert onClick={() => this.handleLink(this.state.installerRequirements)} bsStyle="info" className="alert-with-icon forms-button">
                                        <span data-notify="icon" className="pe-7s-note" />
                                        <span data-notify="message">Wrapify Installation Requirements</span>
                                    </Alert>
                                    <Alert onClick={() => this.handleLink(this.state.installationForm)} bsStyle="info" className="alert-with-icon forms-button">
                                        <span data-notify="icon" className="pe-7s-note" />
                                        <span data-notify="message">Wrapify - Inspection Record - Form 1</span>
                                    </Alert>
                                    <Alert onClick={() => this.handleLink(this.state.removalForm)} bsStyle="info" className="alert-with-icon forms-button">
                                        <span data-notify="icon" className="pe-7s-note" />
                                        <span data-notify="message">Wrapify - Wrap Removal Record - Form 2</span>
                                    </Alert>
                                    <Alert onClick={() => this.handleLink(this.state.photoFormUploads)} bsStyle="info" className="alert-with-icon forms-button">
                                        <span data-notify="icon" className="pe-7s-note" />
                                        <span data-notify="message">Photo & Form Upload </span>
                                    </Alert>
                                </Col>
                                <Col md={8}>

                                </Col>
                            </Row>
                            <br />
                            <br />

                        </div>
                    </div>
                </Grid>
            </div>
        );
    }
}

export default Forms;



// WEBPACK FOOTER //
// ./src/views/Forms/Forms.jsx